const DEFAULT_SITE_URL = 'https://makemyresumes.com';
const DEFAULT_SITE_NAME = 'Make My Resumes';

export const siteUrl = (process.env.REACT_APP_SITE_URL || DEFAULT_SITE_URL).replace(/\/$/, '');
export const siteName = process.env.REACT_APP_SITE_NAME || DEFAULT_SITE_NAME;
export const siteDomain = siteUrl.replace(/^https?:\/\//, '');

/** Parent company that builds and operates this product */
export const companyName = process.env.REACT_APP_COMPANY_NAME || 'DevHopesLabs';
export const companyUrl = (process.env.REACT_APP_COMPANY_URL || 'https://devhopeslabs.com').replace(/\/$/, '');
export const companyContactUrl = `${companyUrl}/contact`;

/** Single inbox for support, legal, privacy, contact form, etc. */
export const contactEmail = process.env.REACT_APP_CONTACT_EMAIL || 'info@devhopeslabs.com';
export const supportEmail = contactEmail;
export const editorialEmail = contactEmail;
export const bugsEmail = contactEmail;
export const privacyEmail = contactEmail;
export const legalEmail = contactEmail;
export const teamAuthor = `${companyName} Team`;
export const shortName = siteName.split(' ')[0];

export const twitterHandle = (process.env.REACT_APP_TWITTER_HANDLE || '').replace(/^@/, '');
const linkedInUrl = process.env.REACT_APP_LINKEDIN_URL || '';

/** Empty when REACT_APP_TWITTER_HANDLE is unset — no footer icon or profile links. */
export const twitterUrl = twitterHandle ? `https://twitter.com/${twitterHandle}` : '';
export const linkedInCompanyUrl = linkedInUrl;

export const socialLinks = [twitterUrl, linkedInCompanyUrl].filter(Boolean);

export const siteConfig = {
  siteUrl,
  siteName,
  siteDomain,
  companyName,
  companyUrl,
  companyContactUrl,
  supportEmail,
  editorialEmail,
  bugsEmail,
  contactEmail,
  privacyEmail,
  legalEmail,
  teamAuthor,
  shortName,
  twitterHandle,
  twitterUrl,
  linkedInCompanyUrl,
  socialLinks,
};

export default siteConfig;
